"use client";

import { useSearchParams } from "next/navigation";

import {
  ArticleItem,
  ArticleItemSkeleton,
  InfinityScrollWrapper,
} from "@/components/partials";
import { VALIDATE_K } from "@/lib/constants";
import { ArticleItemType, PaginatedResType } from "@/lib/schema";
import { calculateReadingTime } from "@/lib/utils";

export default function ArticleList({
  initialData,
  limit = 12,
}: {
  initialData: PaginatedResType<ArticleItemType[]>;
  limit?: number;
}) {
  const sp = useSearchParams();
  const searchParams: Record<string, string> = {};
  const tagIds = sp.getAll("tagIds");
  if (tagIds) searchParams.tagIds = tagIds.join(",");

  return (
    <InfinityScrollWrapper<ArticleItemType>
      initialData={initialData}
      limit={limit}
      staticQuery={searchParams}
      fetchOptions={{ next: { tags: [VALIDATE_K.articles] } }}
      endpoint="/post"
      className="sm:max-w-[690px] mx-auto flex flex-col gap-8 max-sm:gap-4"
      renderItem={(article) => (
        <ArticleItem
          href={`/articles/${article.id}`}
          date={article.created_at}
          description={article.body}
          src={article.banner}
          title={article.title}
          duration={calculateReadingTime(article.body)}
        />
      )}
      renderSkeletonItem={() => <ArticleItemSkeleton />}
    />
  );
}
